import { render, staticRenderFns } from "./card-user.vue?vue&type=template&id=76a11402&scoped=true&"
import script from "./card-user.vue?vue&type=script&lang=js&"
export * from "./card-user.vue?vue&type=script&lang=js&"
import style0 from "./card-user.vue?vue&type=style&index=0&id=76a11402&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a11402",
  null
  
)

export default component.exports